// Register the production service worker so the site is installable as a PWA.
// In development we explicitly unregister to avoid stale caches during hot-reload.

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  if (process.env.NODE_ENV !== "production") {
    // Clean up any leftover SW from previous prod sessions so dev reloads aren't cached
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => {
        // Non-fatal — site still works without offline / installability if SW fails
        // eslint-disable-next-line no-console
        console.warn("Service worker registration failed:", err);
      });
  });
}
